// extracted by mini-css-extract-plugin
module.exports = {"nothingItem":"NothingItem_nothingItem__3AF8H"};